<template>
    <div class="header">
        <div class="header-main">
            <div class="logo" @click="goHome">
                <img :src="logo" alt="">
            </div>
            <div class="navigation-menu">
                <el-menu 
                    :default-active="activeIndex" 
                    mode="horizontal" 
                    @select="handleSelect"
                    text-color="#333333"
                    active-text-color="#003EB0"
                    router
                > 
                    <el-menu-item index="/sample-reports">Sample Reports</el-menu-item>
                    <el-submenu index="2" :popper-append-to-body="false">
                        <template slot="title">Chinese Vehicle History</template>
                        <el-menu-item index="/vehicle-history/introduction">Introduction</el-menu-item>
                        <el-menu-item index="/vehicle-history/vin-introduction">VIN Number</el-menu-item>
                        <el-menu-item index="/vehicle-history/vin-check">VIN Check</el-menu-item>
                        <el-menu-item index="/vehicle-history/how-to-buy">How to buy</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/for-business">For Business</el-menu-item>
                    <el-submenu index="4" :popper-append-to-body="false">
                        <template slot="title">About Lemon Check</template>
                        <el-menu-item index="/about/about-us">About Us</el-menu-item>
                        <el-menu-item index="/about/partner-brand">Partner brand side</el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
            <div class="personal-box">
                <template v-if="$store.state.auth.userInfo">
                    <div class="personal-center" @click="goPersonal">
                        <img :src="personalIcon" alt="" />
                        <div class="person-count">{{ $store.state.auth.userInfo?.email }}</div>
                    </div>
                    <el-dropdown placement="bottom" trigger="click" @command="handleCommand">
                        <div class="menu-area">
                            <i></i><i></i><i></i>
                        </div>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="myReports"> <img :src="menuIcon1" alt="" /><span>My reports</span></el-dropdown-item>
                            <el-dropdown-item divided command="myPackages"> <img :src="menuIcon2" alt="" /><span>My packages</span></el-dropdown-item>
                            <el-dropdown-item divided command="logout"> <img :src="menuIcon3" alt="" /><span>Logout</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
                
                <div class="sign-in" v-else @click="openLoginDialog">
                    <img :src="personalIcon" alt="" />
                    <span>Sign In</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import logo from '@/assets/images/main-logo.png';
import personalIcon from '@/assets/images/icon/personal-icon.png';
import menuIcon1 from '@/assets/images/icon/menu-icon1.png';
import menuIcon2 from '@/assets/images/icon/menu-icon2.png';
import menuIcon3 from '@/assets/images/icon/menu-icon3.png';

export default {
    name: 'Header',
    data() {
        return {
            logo,
            personalIcon,
            menuIcon1,
            menuIcon2,
            menuIcon3
        }
    },
    computed: {
        activeIndex() {
            const path = this.$route.path;
            // 导航菜单里所有可达的路由路径
            const menuPaths = [
                '/sample-reports',
                '/vehicle-history/introduction',
                '/vehicle-history/vin-introduction',
                '/vehicle-history/vin-check',
                '/vehicle-history/how-to-buy',
                '/for-business',
                '/about/about-us',
                '/about/partner-brand'
            ];
            // 当前路由是菜单中的路径时，返回该路径以自动选中对应菜单项
            //（子菜单下的路径会自动高亮并展开对应一级子菜单）
            return menuPaths.includes(path) ? path : '';
        }
    },
    methods: {
        handleSelect(key, keyPath) {

        },
        handleCommand(command) {
            let fullPath = this.$route.fullPath
            switch(command) {
                case 'myReports': 
                    if (fullPath !== "/personal?type=reports") {
                        this.$router.push({
                            path: "/personal",
                            query: {
                                type: "reports"
                            }
                        })
                    }; break;
                case 'myPackages': 
                    if (fullPath !== "/personal?type=packages") {
                        this.$router.push({
                            path: "/personal",
                            query: {
                                type: "packages"
                            }
                        })
                    }; break;
                case 'logout': 
                    this.$confirm('Are you sure you want to log out?', 'prompt', {
                        confirmButtonText: 'Confirm',
                        type: 'warning'
                    }).then(() => {
                        this.$store.dispatch("auth/clearAuthentication"); 
                    }).catch(() => {})
                    break;
            }
        },
        openLoginDialog() {
            this.$store.dispatch('auth/openLoginDialog');
        },
        goHome() {
            if (this.$route.path != "/") {
                this.$router.push("/")
            }
        },
        goPersonal() {
            this.$router.push({
                path: "/personal",
                query: {
                    type: "reports"
                }
            }).catch(() => {})
        }
    }
}
</script>
<style scoped lang="scss">
// 原公共子菜单样式，挂载到body之外的
// .el-menu--popup {
//     .el-menu-item {
//         height: 70px !important;
//         line-height: 70px !important;
//         text-align: center;
//     }
//     .el-menu-item:hover {
//         background-color: rgba(0, 71, 255, 0.1) !important;
//         color: #0047FF !important;
//     }
// }
.el-dropdown-menu {
    border-radius: 12px;
    .el-dropdown-menu__item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 70px;
        width: 245px;
        padding-left: 48px;
        img {
            width: 18px;
            height: 18px;
        }
        span {
            margin-left: 10px;
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0em;
            color: #333333;
        }
    }
    .el-dropdown-menu__item--divided:before {
        margin: 0;
    }
}
.header {
    position: relative;
    // 需要抬高 header 的层级，避免弹层被下方主内容区（z-index: 1/2）盖住
    z-index: 100;
    width: 100%;
    background: linear-gradient(180deg, #ffffff7a 0%, #ffffff99 100%);
    backdrop-filter: blur(20px);
    height: 70px;
    .header-main {
        width: 1600px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
            width: 246px;
            height: 40px;
            cursor: pointer;
            img {
                width: 246px;
                height: 40px;
            }
        }
        .navigation-menu {
            ::v-deep .el-menu {
                border-bottom: none !important;
                .el-menu-item {
                    font-family: "Alibaba PuHuiTi 3.0";
                    font-size: 18px;
                    letter-spacing: -0.02em;
                    font-weight: 500;
                    height: 70px;
                    line-height: 70px;
                }
                .el-submenu__title {
                    font-family: "Alibaba PuHuiTi 3.0";
                    font-size: 18px;
                    letter-spacing: -0.02em;
                    font-weight: 500;
                    height: 70px;
                    line-height: 70px;
                }
                /* 子菜单标题悬停样式 */
                // .el-submenu__title:hover {
                //     background-color: #1890ff !important;  /* 悬停背景色 */
                //     color: white !important;               /* 悬停文字色 */
                // }
            }

            /* element-ui 横向菜单的 li.el-submenu 默认没有 position: relative，需显式声明
               才能让弹层以其为定位基准 */
            ::v-deep .el-submenu {
                position: relative;
            }

            /* 二级菜单弹层相对一级菜单容器水平居中：
               包裹层 left: 50% 对齐到容器中线，内层 ul 再向左回移自身宽度一半。
               （不能用 transform: translateX(-50%) 居中，transform 已被下方的
               过渡覆盖规则占用） */
            ::v-deep .el-submenu .el-menu--horizontal {
                left: 50% !important;
                // 包裹层因 left: 50% 偏移，盒子右半是空白区，会拦截鼠标导致鼠标划出菜单视觉范围后菜单不消失。禁掉包裹层本身的鼠标命中，
                // 交给下面的 ul 二级菜单子项 恢复
                pointer-events: none;
            }
            ::v-deep .el-submenu .el-menu--popup {
                position: relative;
                left: -50%;
                // 菜单内容本身恢复鼠标命中（悬停展开、点击跳转不受影响）
                pointer-events: auto;
                // 子菜单样式
                .el-menu-item {
                    height: 70px !important;
                    line-height: 70px !important;
                    text-align: center;
                }
                .el-menu-item:hover {
                    background-color: rgba(0, 71, 255, 0.1) !important;
                    color: #0047FF !important;
                }
                /* 基础态：负 inset 向外扩 40px，保证 ul 的 box-shadow 不被裁掉，
                   并作为裁切动画的插值终点（clip-path 不能在 none 与 inset() 间插值） */
                clip-path: inset(-40px -40px -40px -40px);
                transition: clip-path 0.3s cubic-bezier(0.23, 1, 0.32, 1);
            }

            /* 重写 el-menu 的菜单弹出动画效果
                保留 zoom-in-top“自上而下展开”的动画效果，但把实现从
               transform: scaleY(0->1)（会把文字垂直压缩再拉伸，导致文字抖动）
               换成 clip-path: inset() 裁切展开——文字全程以原尺寸渲染，无变形。
               裁切必须挂在内层 .el-menu--popup 上：它因 left: -50% 回移会向左
               溢出包裹层一半宽度，若挂在包裹层上，溢出的左半会被裁掉，
               出现“动画时只显示右半、结束后左半才出现”的错位 */
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-enter-active,
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-leave-active {
                transform: none !important;
                transform-origin: center top;
                transition: opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1) !important;
            }
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-enter .el-menu--popup,
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-leave-to .el-menu--popup,
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-leave-active .el-menu--popup {
                clip-path: inset(-40px -40px 100% -40px);
            }
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-enter,
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-leave-to,
            ::v-deep .el-submenu .el-menu--horizontal.el-zoom-in-top-leave-active {
                opacity: 0;
                transform: none !important;
            }
        }
        .personal-box {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-family: "Alibaba PuHuiTi 3.0";
            .personal-center {
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #F6F6F6;
                background: #FFFFFF;
                border-radius: 8px;
                padding: 8px 24px;
                cursor: pointer;
                margin-right: 12px;
                img {
                    width: 20px;
                    height: 20px;
                }
                .person-count {
                    font-size: 16px;
                    color: #333333;
                    letter-spacing: -0.02em;
                    font-weight: 500;
                }
            }
            .menu-area {
                border: 1px solid #F6F6F6;
                box-sizing: border-box;
                background: #FFFFFF;
                border-radius: 8px;
                display: flex;
                flex-direction:column;
                align-items: center;
                justify-content: center;
                width: 38px;
                height: 38px;
                cursor: pointer;
                i {
                    display: block;
                    width: 15px;
                    height: 3px;
                    border-radius: 2px;
                    background: #333333;
                    &:nth-child(2) {
                        margin: 2px 0;
                    }
                }
            }
            .sign-in {
                margin-left: 12px;
                background: #FFCD02;
                padding: 8px 24px;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img {
                    width: 20px;
                    height: 20px;
                }
                span {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: normal;
                    letter-spacing: -0.02em;
                    color: #333333;
                }
            }
        }
    }
}
</style>
